import './styles.scss'
import React from 'react'
import { connect } from 'react-redux'
import { I18n } from 'react-redux-i18n'

const FormSteps = (props) => {
  const { step } = props
  const getActiveForStep = (step, stepNumber) => {
    return step === stepNumber ? 'current' : step >= stepNumber ? 'active' : ''
  }
  return (
    <ul className='form-steps text-center'>
      <li className={getActiveForStep(step, 1)} id='step1'>
        {I18n.t('dashboard_about-campaign')}
        <span className='icon' />
      </li>
      <li className={getActiveForStep(step, 2)} id='step2'>
        {I18n.t('campaign_step_user_segmentation')}
        <span className='icon' />
      </li>
      <li className={getActiveForStep(step, 3)} id='step3'>
        {I18n.t('dashboard_messages')}
        <span className='icon' />
      </li>
      <li className={getActiveForStep(step, 4)} id='step4'>
        {I18n.t('campaign_step_launch_campaign')}
        <span className='icon' />
      </li>
    </ul>
  )
}

export default connect()(FormSteps)
